/* ══════════════════════════════════════════════════════════
   Tienda agrupada — filtrado en cliente

   Dos ejes independientes:
     • Pestaña de categoría (una a la vez, "all" muestra todos los grupos)
     • Chip de momento de uso (uno a la vez, se puede quitar)

   Una tarjeta se ve si pertenece a la categoría activa Y tiene el uso
   activo. Un grupo se oculta si se queda sin tarjetas visibles.
   Los contadores de las pestañas se recalculan con el chip aplicado.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* La fila de swatches se desliza en horizontal cuando no cabe (CSS puro:
     overflow-x + scroll-snap). No hace falta JS: no hay degradado ni estados
     que sincronizar. */

  function initShop(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ws-tab]'));
    if (!tabs.length) return;

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ws-chip]'));
    var clearBtn = root.querySelector('[data-ws-chip-clear]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ws-group]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.ws__item'));
    var emptyMsg = root.querySelector('[data-ws-empty]');

    var activeTab = 'all';
    var activeChip = null;

    function matchesChip(item) {
      if (!activeChip) return true;
      var usos = ' ' + (item.dataset.wsUsos || '') + ' ';
      return usos.indexOf(' ' + activeChip + ' ') !== -1;
    }

    function apply() {
      var counts = { all: 0 };
      var visibleTotal = 0;

      items.forEach(function (item) {
        var cat = item.dataset.wsCat;
        var byChip = matchesChip(item);

        // Los contadores reflejan el chip, no la pestaña: así el usuario ve
        // cuántos productos le quedan en cada categoría antes de tocarla.
        if (byChip) {
          counts[cat] = (counts[cat] || 0) + 1;
          counts.all += 1;
        }

        var visible = byChip && (activeTab === 'all' || activeTab === cat);
        item.hidden = !visible;
        if (visible) visibleTotal += 1;
      });

      groups.forEach(function (g) {
        var tag = g.dataset.wsGroup;
        var inTab = activeTab === 'all' || activeTab === tag;
        var hasVisible = !!g.querySelector('.ws__item:not([hidden])');
        g.hidden = !(inTab && hasVisible);
      });

      tabs.forEach(function (t) {
        var key = t.dataset.wsTab;
        var el = t.querySelector('[data-ws-count]');
        var n = counts[key] || 0;
        if (el) el.textContent = n;
        // Una pestaña sin resultados bajo el chip activo se apaga, pero no
        // se esconde: mover elementos de sitio desorienta más que atenuarlos.
        t.disabled = n === 0 && key !== activeTab;
        t.classList.toggle('is-empty', n === 0);
      });

      if (emptyMsg) emptyMsg.hidden = visibleTotal > 0;
      if (clearBtn) clearBtn.hidden = !activeChip;
    }

    function setTab(key) {
      activeTab = key;
      tabs.forEach(function (t) {
        var on = t.dataset.wsTab === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      apply();
    }

    function setChip(tag) {
      activeChip = tag;
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.dataset.wsChip === tag ? 'true' : 'false');
      });
      apply();
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { setTab(t.dataset.wsTab); });
    });

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        setChip(activeChip === c.dataset.wsChip ? null : c.dataset.wsChip);
      });
    });

    if (clearBtn) clearBtn.addEventListener('click', function () { setChip(null); });

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-ws]').forEach(initShop);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ws]');
    if (el) initShop(el);
  });
})();
